import { render, staticRenderFns } from "./UserDialog.vue?vue&type=template&id=33342c95&scoped=true&"
import script from "./UserDialog.vue?vue&type=script&lang=ts&"
export * from "./UserDialog.vue?vue&type=script&lang=ts&"
import style0 from "./UserDialog.vue?vue&type=style&index=0&id=33342c95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33342c95",
  null
  
)

export default component.exports